const MIN_ZOOM = 1;
const MAX_ZOOM = 5;

function finiteOr(value, fallback) {
  return Number.isFinite(value) ? value : fallback;
}

function nonNegativeDimension(value) {
  return Math.max(0, finiteOr(value, 0));
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function clampZoom(value) {
  return clamp(finiteOr(value, MIN_ZOOM), MIN_ZOOM, MAX_ZOOM);
}

function clampViewport(viewport = {}, width, height) {
  const zoom = clampZoom(viewport.zoom);
  const safeWidth = nonNegativeDimension(width);
  const safeHeight = nonNegativeDimension(height);
  const minX = safeWidth - safeWidth * zoom;
  const minY = safeHeight - safeHeight * zoom;

  return {
    zoom,
    x: clamp(finiteOr(viewport.x, 0), finiteOr(minX, 0), 0),
    y: clamp(finiteOr(viewport.y, 0), finiteOr(minY, 0), 0),
  };
}

function zoomAt(viewport = {}, nextZoom, point = {}, width, height) {
  const current = clampViewport(viewport, width, height);
  const safePointX = finiteOr(point.x, 0);
  const safePointY = finiteOr(point.y, 0);
  const zoom = clampZoom(nextZoom);
  const worldX = (safePointX - current.x) / current.zoom;
  const worldY = (safePointY - current.y) / current.zoom;

  return clampViewport(
    {
      zoom,
      x: finiteOr(safePointX - worldX * zoom, 0),
      y: finiteOr(safePointY - worldY * zoom, 0),
    },
    width,
    height,
  );
}

function screenToCanvas(point = {}, viewport = {}) {
  const zoom = clampZoom(viewport.zoom);
  const x = finiteOr(point.x, 0);
  const y = finiteOr(point.y, 0);

  return {
    x: finiteOr((x - finiteOr(viewport.x, 0)) / zoom, 0),
    y: finiteOr((y - finiteOr(viewport.y, 0)) / zoom, 0),
  };
}

function resizeViewport(viewport = {}, oldWidth, oldHeight, newWidth, newHeight) {
  const oldW = nonNegativeDimension(oldWidth);
  const oldH = nonNegativeDimension(oldHeight);
  const newW = nonNegativeDimension(newWidth);
  const newH = nonNegativeDimension(newHeight);
  const current = clampViewport(viewport, oldW, oldH);
  const centerX = oldW > 0
    ? finiteOr((oldW / 2 - current.x) / current.zoom / oldW, 0.5)
    : 0.5;
  const centerY = oldH > 0
    ? finiteOr((oldH / 2 - current.y) / current.zoom / oldH, 0.5)
    : 0.5;

  return clampViewport(
    {
      zoom: current.zoom,
      x: newW / 2 - centerX * newW * current.zoom,
      y: newH / 2 - centerY * newH * current.zoom,
    },
    newW,
    newH,
  );
}

module.exports = {
  MIN_ZOOM,
  MAX_ZOOM,
  clampZoom,
  clampViewport,
  zoomAt,
  screenToCanvas,
  resizeViewport,
};